// extracted by mini-css-extract-plugin
module.exports = {"manualInput":"styles_manualInput__1PiY0","manualInput__small":"styles_manualInput__small__19F9d"};